import type { ReactNode } from 'react';

import { Sidebar } from '../components/Sidebar';

interface AdminShellProps {
  children: ReactNode;
}

/**
 * 데스크탑 레이아웃 (docs/design/dashfolio-dna.md §4).
 *
 * `.admin-root` scope 가 최상위에 적용되어 @lashpic/ui/admin 토큰이 활성화.
 * 기본 테마는 다크 — 사용자가 `data-theme="light"` 토글 시 라이트 모드.
 *
 * 레이아웃: 좌측 256px 사이드바 + 중앙 집중 1280px 메인 컨텐츠.
 */
export function AdminShell({ children }: AdminShellProps) {
  return (
    <div className="admin-root dark flex min-h-dvh bg-[var(--color-admin-window)] text-[var(--color-admin-text)]">
      <Sidebar />
      <main className="flex-1 overflow-y-auto">
        <div className="mx-auto w-full max-w-[1280px] px-6 py-8 lg:px-10">
          {children}
        </div>
      </main>
    </div>
  );
}
